import * as classNames from "classnames";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { LayoutContainer } from "@components/student/LayoutContainer";
import { emailAddress, facebookLink, instagramLink, prettifyPhoneNumber, telegramLink, } from "@constants";
import { safeFbq } from "@utils/analytics";
import * as s from "./Footer.sss";
import { useCitiesQuery } from "@/graphql";
export const Footer = ({ className }) => {
    const { t } = useTranslation();
    const { data: { cities }, loading, } = useCitiesQuery();
    const cityId = localStorage.getItem("cityId") || cities[0].id.toString();
    const currentLocation = cities.find(({ id }) => id.toString() === cityId);
    const phoneNumber = prettifyPhoneNumber(currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.phoneNumber);
    return (React.createElement("div", { className: classNames(s.root, className) },
        React.createElement(LayoutContainer, { className: s.content },
            React.createElement("div", { className: s.iconLinks },
                React.createElement("p", null, t("student~Мы в социальных сетях")),
                React.createElement("div", { className: s.socialLinks },
                    React.createElement("a", { className: s.socialLink, href: instagramLink, target: "_blank", rel: "noreferrer" }, "Instagram"),
                    React.createElement("a", { className: s.socialLink, href: facebookLink, target: "_blank", rel: "noreferrer" }, "Facebook"),
                    React.createElement("a", { className: s.socialLink, href: telegramLink, target: "_blank", rel: "noreferrer" }, "Telegram"))),
            React.createElement("div", { className: s.contactsSection },
                React.createElement("p", null, t("student~Номер телефона")),
                React.createElement("a", { className: s.phone, href: phoneNumber, onClick: () => safeFbq("track", "Contacts") }, phoneNumber)),
            React.createElement("div", { className: s.contactsSection },
                React.createElement("p", null, t("student~Почта")),
                React.createElement("a", { href: `mailto:${emailAddress}` }, emailAddress)))));
};
